import React from 'react';
import {
  getHeroContent, HeroImage, StoreLogo, SearchBar, CartBtn, TabContent, StoreFooter, FaHeart, getTabLabel, InlineEditableText
} from './ThemeLayoutHelpers';


export default function TideLayout({ p }) {
  const T = p.storeTheme || {};
  const primary = T.primaryColor || "#0ea5e9";
  const text = p.storefrontText || {};
  const copy = getHeroContent(p, {
    eyebrow: "Tide • Lifestyle",
    title: "Oceanic vibes for modern living.",
    subtitle: "Curated lifestyle products with a fresh coastal aesthetic.",
    primaryCta: "Explore Collection",
  });
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: T.backgroundColor || "#f0f9ff", fontFamily: T.fontFamily || "Inter, sans-serif" }}>
      <nav className="sticky top-0 z-40 border-b border-sky-200 bg-[#f0f9ff]/90 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-3">
          <StoreLogo storeInfo={p.storeInfo} border="border-2 border-sky-300" />
          <div>
            <p className="text-sm font-bold text-sky-900">{p.storeInfo?.businessName}</p>
            <p className="text-[10px] text-sky-500 font-medium tracking-wide">{p.storeInfo?.businessCategory || text.storeInfo || "Store Info"}</p>
          </div>
          <SearchBar searchQuery={p.searchQuery} setSearchQuery={p.setSearchQuery} theme={T} className="flex-1 hidden md:block ml-3" />
          <div className="ml-auto flex items-center gap-2">
            <button onClick={p.handleGoToWishlist} className="relative p-2 rounded-xl border border-sky-200 hover:bg-sky-100" style={{ color: primary }}>
              <FaHeart className="text-base" />
              {p.wishlistCount > 0 && <span className="absolute -top-1 -right-1 h-4 w-4 text-[9px] rounded-full text-white flex items-center justify-center" style={{ backgroundColor: primary }}>{p.wishlistCount}</span>}
            </button>
            <CartBtn p={p} />
            {p.userMenuElement}
          </div>
        </div>
      </nav>
      <section className="max-w-7xl mx-auto w-full px-4 pt-6">
        <div className="grid grid-cols-1 lg:grid-cols-[1.4fr_0.6fr] gap-5">
          <div className="rounded-3xl overflow-hidden shadow-[0_18px_55px_rgba(2,132,199,0.3)]">
            <HeroImage p={p} themeId="tide" className="h-[340px] md:h-[400px]">
              <div className="absolute inset-0 bg-gradient-to-t from-sky-950/75 via-sky-900/25 to-transparent pointer-events-none" />
              <div className="absolute bottom-0 inset-x-0 p-7 text-white">
                <span className="text-[10px] uppercase tracking-[0.26em] font-bold text-sky-200/70"><InlineEditableText p={p} field="heroEyebrow" value={copy.eyebrow}>{copy.eyebrow}</InlineEditableText></span>
                <h1 className="text-4xl font-extrabold mt-2 leading-tight"><InlineEditableText p={p} field="heroTitle" value={copy.title}>{copy.title}</InlineEditableText></h1>
                <p className="text-white/65 mt-2 text-sm"><InlineEditableText p={p} field="heroSubtitle" value={copy.subtitle}>{copy.subtitle}</InlineEditableText></p>
                <button onClick={() => p.setActiveTab("products")} className="mt-5 px-6 py-3 rounded-xl text-sm font-bold text-white shadow-lg" style={{ backgroundColor: primary }}><InlineEditableText p={p} field="primaryCtaText" value={copy.primaryCta}>{copy.primaryCta}</InlineEditableText></button>
              </div>
            </HeroImage>
          </div>
          <div className="flex flex-col gap-4">
            <div className="rounded-3xl border border-sky-200 bg-white p-5 shadow-sm flex-1">
              <p className="text-xs uppercase tracking-[0.18em] text-sky-700 font-bold mb-3">{text.storeInfo || "Store Info"}</p>
              {[{l:text.products || "Products", v:p.filteredProducts?.length||0},{l:text.services || "Services", v:p.filteredServices?.length||0}].map(s => (
                <div key={s.l} className="rounded-xl border border-sky-100 bg-sky-50 px-4 py-3 mb-2">
                  <p className="text-xs text-sky-600 font-semibold">{s.l}</p>
                  <p className="text-2xl font-extrabold text-sky-900 mt-0.5">{s.v}</p>
                </div>
              ))}
              <button onClick={() => p.setActiveTab("products")} className="mt-2 w-full py-3 rounded-xl text-sm font-bold text-white" style={{ backgroundColor: primary }}>{text.shopNow || "Shop Now"}</button>
            </div>
          </div>
        </div>
      </section>
      <section className="max-w-7xl mx-auto w-full px-4 mt-5">
        <div className="rounded-2xl border border-sky-200 bg-white p-1.5 flex gap-1.5 overflow-x-auto">
          {[["products", getTabLabel(p, "products")],["services", getTabLabel(p, "services")],["details", getTabLabel(p, "details")]].map(([k,l]) => (
            <button key={k} onClick={() => p.setActiveTab(k)} className="px-5 py-2 rounded-xl text-sm font-semibold whitespace-nowrap" style={p.activeTab===k ? { backgroundColor: primary, color:"#fff" } : { color:"#0c4a6e" }}>{l}</button>
          ))}
        </div>
      </section>
      <section className="flex-1 max-w-7xl mx-auto w-full px-4 py-6"><TabContent p={p} /></section>
      <StoreFooter p={p} />
    </div>
  );
}

// ─── Aurora ──────────────────────────────────────────────────────────────────